import { PageVisibleFields } from '../types';
import { eventDataProcessor } from './event-data-processor';
import { metalDataProcessor } from './metal-data-processor';
import { makeShareableGlobalConfig } from './shareable-global-config';
export const submitter = {
  debug: false,
  config: {
    gasv3: undefined,
    metal: undefined,
    configChunk: null,
    useVisibleState: false,
    histogram: {}
  },

  configure(config) {
    this.config.gasv3 = config.endpoints.eventPipelineClient;
    this.config.metal = config.endpoints.metalClient;
    this.config.configChunk = makeShareableGlobalConfig(config);

    if (config.events.all && config.events.all.sfxEvents) {
      this.config.useVisibleState = config.events.all.sfxEvents.activeTab === PageVisibleFields.pageVisibleState;
    }
  },

  setDebug(debug) {
    this.debug = debug;
  },

  async queue(data) {
    if (!this.config.configChunk) {
      // eslint-disable-next-line no-console
      this.debug && console.warn('Submitter is not configured');
      return null;
    }

    const chunk = await this.config.configChunk;
    const payload = await eventDataProcessor(chunk[data.config.type], data);

    if (payload === null) {
      return;
    }

    if (this.config.gasv3 !== undefined) {
      const client = await this.config.gasv3;
      const attributes = {
        task: payload['event:key'],
        properties: payload
      };
      client && client.sendOperationalEvent({
        actionSubject: 'performance',
        attributes,
        source: 'performance',
        action: 'measured'
      });
    }

    if (this.config.metal !== undefined) {
      const metal = await this.config.metal;

      if (metal && metal.metric) {
        const metalEvents = metalDataProcessor(payload, this.config.useVisibleState);

        if (metalEvents && metalEvents.length > 0) {
          metalEvents.forEach(eventData => {
            metal.metric.submit(eventData);
          });
        }
      }
    }
  }

};